import { i18n } from '@/lang';

export default {
    url: {
        validation_url_0036: i18n.t('l_check_url'),
    },
};
